import { useApplicationContext } from 'shared/utils/applicationContext';
import { SmbContentContainer } from '../Smb';
import { SobContentContainer } from '../Sob';
import { HostContentContainer } from '../Host';

export const PagesContainer: React.FC = () => {
  const {
    custom: { pageType },
  } = useApplicationContext();

  if (pageType === 'sob') {
    return <SobContentContainer />;
  }

  if (pageType === 'host') {
    return <HostContentContainer />;
  }

  return <SmbContentContainer />;
};
